import { render, staticRenderFns } from "./NewSlider.vue?vue&type=template&id=88062cc8&"
import script from "./NewSlider.vue?vue&type=script&lang=js&"
export * from "./NewSlider.vue?vue&type=script&lang=js&"
import style0 from "./NewSlider.vue?vue&type=style&index=0&id=88062cc8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports